export enum TransferMode {
  DOWNLOAD = 0,
  UPLOAD = 1,
}
